import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongsMobileFilterGroupGenresLogic} from "./SongsMobileFilterGroupGenres.logic";
import {DisclosureGroup} from "../../../../../../components/common/disclosure-group/DisclosureGroup";
import {FilterGenres} from "../../../../../../modules/songs/filter-genres/FilterGenres";

export const SongsMobileFilterGroupGenres: VoidFunctionComponent = () => {
  const {filterLabel} = useSongsMobileFilterGroupGenresLogic();
  return (
    <DisclosureGroup title={"Genres"} secondaryInfo={filterLabel}>
      <FilterGenres />
    </DisclosureGroup>
  );
}
